import React from 'react'
import './ComponentBoxFooter.css'
import { CardFooter } from 'reactstrap'

type ComponentBoxFooterProps = {
  children?: React.ReactNode
}

const ComponentBoxFooter = ({ children }: ComponentBoxFooterProps) => {
  return (
    <div className='footer-container'>
      <CardFooter
        className='footer'
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          minHeight: '3rem',
        }}
      >
        {children}
      </CardFooter>
    </div>
  )
}

export default ComponentBoxFooter
